import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { useForm, Controller } from "react-hook-form";
import { Tab, Tabs, Form } from "react-bootstrap";
import {
  roles,
  countryConstants,
  translationConstants,
  fieldLengthConstants,
  Directions,
  preferedLanguagesContants,
  bloodTypes,
} from "../../../../../constants";
import { authActions, UserActions } from "../../../../../redux/actions/";
import ReactDatePickerWrapper from "../../../../../shared/components/ReactDatePickerWrapper/ReactDatePickerWrapper";
import { serverFormatToDateObject } from "../../../../../system";
import AdminCertificateView from "../../../../../shared/components/ApproveRejectCertificate/AdminCertificateView";

const ViewInstructorApproval = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const userDataObject = useSelector(
    (state) => state.InstructorReducer.instructorData
  );
  const userData = userDataObject?.userInfo;
  const cities = useSelector((state) => state.LoginReducer.cities);
  const userDocuments = userDataObject?.documentsOrCertificates;
  const [startDate, setStartDate] = useState(new Date("1/1/1990"));
  const [key, setKey] = useState("");

  const countries = useSelector((state) => state.LoginReducer.countries);
  const {
    setValue,
    register,
    control,
    formState: { errors },
  } = useForm();

  const getDocumentID = (documentId) => {};

  useEffect(() => {
    if (userData?.countryId === Number(countryConstants.SAUDIA_ARABIA)) {
      if (cities.length <= 0) {
        dispatch(authActions.fetchCities(userData?.countryId));
      }
    }
    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    setValue("firstName", userData?.englishFirstName);
    setValue("lastName", userData?.englishLastName);
    setValue("firstNameArabic", userData?.arabicFirstName);
    setValue("lastNameArabic", userData?.arabicLastName);
    setValue("email", userData?.email);
    setValue("verifiedDoc", userData?.arabicFirstName);
    setValue("phoneNumber", userData?.phoneNumber);
    if (userData?.dobString) {
      const dateObject = serverFormatToDateObject(userData.dobString);
      setStartDate(dateObject);
      setValue("dateOfBirth", dateObject, {
        shouldValidate: true,
      });
    }
    setValue("gender", userData?.gender);
    setValue("nationality", userData?.nationality);
    setValue("countryresidence", userData?.countryId);
    setValue("cityresidence", userData?.cityId);
    setValue("preferredLangauge", userData?.preferredLangauge);
    setValue("bloodGroup", userData?.bloodGroup);
    setKey(
      userData?.role === roles.GeneralUser ? "Documents" : "qualifications"
    );
    // eslint-disable-next-line
  }, [countries, userDataObject, cities]);

  const HandleModal = (event, fileDetails) => {
    if (event.target.name === "rejected") {
      dispatch(
        UserActions.OpenAppRejModal({
          modalStatus: true,
          eventType: "rejected",
          userEmail: userData.email,
          userID: userData.id,
          fileDetails: fileDetails,
        })
      );
    } else if (event.target.name === "approved") {
      dispatch(
        UserActions.OpenAppRejModal({
          modalStatus: true,
          eventType: "approved",
          userEmail: userData.email,
          userID: userData.id,
          fileDetails: fileDetails,
        })
      );
    }
  };
  return (
    <div>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {t(translationConstants.INSTRUCTOR_REQUEST)}
        </p>
      </div>
      <p className="horizentalLine" />

      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="nav-links mt-4 "
      >
        <Tab
          className="mt-4 "
          eventKey="General"
          title={t(translationConstants.general)}
        >
          <Form noValidate className="ViewUserContent ViewUserContentForm">
            {/* firstLastName */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.firstName)}:
                </Form.Label>
                <Form.Control
                  {...register("firstName", {})}
                  id="firstName"
                  disabled={true}
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  type="text"
                />
                {errors.firstName && (
                  <p className="errorText">{errors.firstName.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.lastName)}:
                </Form.Label>
                <Form.Control
                  {...register("lastName", {})}
                  id="lastName"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  disabled={true}
                  type="text"
                />
                {errors.lastName && (
                  <p className="errorText">{errors.lastName.message}</p>
                )}
              </Form.Group>
            </div>

            {/* arabiclastName */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.firstNameArabic)}:{" "}
                  <span>{t(translationConstants.optional)}</span>{" "}
                </Form.Label>
                <Form.Control
                  {...register("firstNameArabic", {})}
                  id="firstNameArabic"
                  type="text"
                  disabled={true}
                  style={{ direction: Directions.rtl }}
                />
                {errors.firstNameArabic && (
                  <p className="errorText">{errors.firstNameArabic.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.lastNameArabic)}:{" "}
                  <span>{t(translationConstants.optional)}</span>
                </Form.Label>
                <Form.Control
                  {...register("lastNameArabic", {})}
                  id="lastNameArabic"
                  disabled={true}
                  type="text"
                  style={{ direction: Directions.rtl }}
                />
                {errors.lastNameArabic && (
                  <p className="errorText">{errors.lastNameArabic.message}</p>
                )}
              </Form.Group>
            </div>

            {/* emailPhoneNumber */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.email)}
                </Form.Label>
                <Form.Control
                  {...register("email", {})}
                  id="email"
                  maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
                  disabled={true}
                  type="email"
                />
                {errors.email && (
                  <p className="errorText">{errors.email.message}</p>
                )}
              </Form.Group>
              <Form.Group className="form-phone-group-max-width">
                <Form.Label className="Form-labels">
                  {t(translationConstants.phoneNumber)}:
                </Form.Label>

                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field: { value } }) => (
                    <PhoneInput
                      defaultCountry="sa"
                      value={value}
                      disabled={true}
                      maxLength={fieldLengthConstants.PHONENUMBER_FIELD_LENGTH}
                    />
                  )}
                />
                {errors.phoneNumber && (
                  <p className="errorText">{errors.phoneNumber.message}</p>
                )}
              </Form.Group>
            </div>

            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.dateOfBirth)}:
                </Form.Label>
                <Controller
                  name="dateOfBirth"
                  control={control}
                  rules={{
                    required: t(translationConstants.dateOfBirthRequired),
                  }}
                  render={({ field }) => (
                    <div className="react-datepicker-wrapper-parent disabled-bg">
                      <ReactDatePickerWrapper
                        disabled={true}
                        selected={startDate}
                      />
                    </div>
                  )}
                />
                {errors.dateOfBirth && (
                  <p className="errorText">{errors.dateOfBirth.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.gender)}:
                </Form.Label>
                <Form.Select
                  disabled={true}
                  {...register("gender", {
                    required: t(translationConstants.genderSelectionRequired),
                  })}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.selectGender)}
                  </option>
                  <option value={0}>{t(translationConstants.male)}</option>
                  <option value={1}>{t(translationConstants.female)}</option>
                </Form.Select>
                {errors.gender && (
                  <p className="errorText">{errors.gender.message}</p>
                )}
              </Form.Group>
            </div>

            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.nationality)}:
                </Form.Label>
                <Form.Control
                  {...register("nationality", {})}
                  id="nationality"
                  disabled={true}
                  type="text"
                />
                {errors.nationality && (
                  <p className="errorText">{errors.nationality.message}</p>
                )}
              </Form.Group>
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.countryOfResidence)}:
                </Form.Label>
                <Form.Select
                  {...register("countryresidence", {
                    required: t(translationConstants.countryResidenceRequired),
                  })}
                  disabled={true}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.selectresidence)}
                  </option>
                  {countries?.data?.map((residence) => (
                    <option key={residence.id} value={residence.id}>
                      {residence.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.countryresidence && (
                  <p className="errorText">{errors.countryresidence.message}</p>
                )}
              </Form.Group>

              {userData?.countryId ===
                Number(countryConstants.SAUDIA_ARABIA) && (
                <Form.Group className="form-group-register">
                  <Form.Label
                    htmlFor="cityResidenceSelect"
                    className="Form-labels"
                  >
                    {" "}
                    {t(translationConstants.cityofresidence)}
                  </Form.Label>
                  <Form.Select
                    id="cityResidenceSelect"
                    {...register("cityresidence", {
                      required: t(translationConstants.cityResidenceRequired),
                    })}
                    disabled={true}
                    aria-label="Default select example"
                  >
                    <option value="">
                      {t(translationConstants.selectcity)}
                    </option>
                    {cities?.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.cityresidence && (
                    <p className="errorText">{errors.cityresidence.message}</p>
                  )}
                </Form.Group>
              )}
              <Form.Group className="form-group-register">
                <Form.Label
                  htmlFor="preferredLanguageSelect"
                  className="Form-labels"
                >
                  {t(translationConstants.PREFERRED_LANGUAGE)}:
                </Form.Label>
                <Form.Select
                  id="preferredLanguageSelect"
                  {...register("preferredLangauge", {
                    required: t(
                      translationConstants.SELECT_PREFERRED_LANGUAGE_Required
                    ),
                  })}
                  disabled={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValue("preferredLangauge", value, {
                      shouldValidate: true,
                    });
                    e.stopPropagation();
                  }}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.SELECT_PREFERRED_LANGUAGE)}
                  </option>
                  <option value="0">{preferedLanguagesContants.Arabic}</option>
                  <option value="1">{preferedLanguagesContants.English}</option>
                </Form.Select>
                {errors.preferredLangauge && (
                  <p className="errorText">
                    {errors.preferredLangauge.message}
                  </p>
                )}
              </Form.Group>
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.BLOOD_GROUP)}:
                </Form.Label>
                <Form.Select
                  className="custom-select-icon"
                  {...register("bloodGroup", {
                    required: t(translationConstants.BLOOD_GROUP_REQUIRED),
                  })}
                  disabled={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValue("bloodGroup", value, {
                      shouldValidate: true,
                    });
                    e.stopPropagation();
                  }}
                >
                  <option value="">
                    {t(translationConstants.SELECT_BLOOD_GROUP)}
                  </option>
                  {Object.values(bloodTypes).map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Form.Select>
                {errors.bloodGroup && (
                  <p className="errorText">{errors.bloodGroup.message}</p>
                )}
              </Form.Group>
            </div>
          </Form>
        </Tab>
        <Tab
          eventKey="qualifications"
          title={t(translationConstants.QUALIFICATIONS)}
        >
          <AdminCertificateView
            isInstructorView={true}
            isViewCertificatesOnly={false}
            certificates={userDocuments}
            approveRejectHandler={HandleModal}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ViewInstructorApproval;
